import { IGetSetoresDropDownUseCase } from "../../../presentation/useCases/read/get_setores_drop_down_use_case";
import { FuncionarioSetorDropDown } from "../../models/funcionario_setor_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetSetoresDropDownUseCase
 */

export class GetSetoresDropDownUseCase implements IGetSetoresDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFuncionarioSetoresDropDown(): Promise<FuncionarioSetorDropDown[]> {
    return await this.repository.getFuncionarioSetoresDropDown();
  }
}
